import { useContext, useState } from "react";
import BryntumContext from "@/react/context/bryntumContext";
// @ts-expect-error - userPreferences is dynamically set in bryntumContext
import { userPreferences } from "@/react/context/bryntumContext.jsx";
import { publishContextCards } from "@/network/network";
import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys";
import { BoardPreferences } from "@/bryntum-lib/models/BoardPreferences";
import { toast } from "sonner";
import { isIAmOneOfBoardOwner } from "@/other/utils/utils";

export const usePublishContextCards = () => {
  const { user, project, boardManager, selectedBoard } = useContext(BryntumContext);
  const [isPublishing, setIsPublishing] = useState(false);

  useSwivuStore({ storeId: STORE_KEYS.boardPreferencesStore, subscriberFn: ({ record }: { record: BoardPreferences }) => record.key === PERSISTENCE_STATE_KEYS.aiContextCardInDraft });

  // Permission check: board owner only, excluding demo users
  // @ts-expect-error - boardManager is dynamically set in bryntumContext
  const boardStore = boardManager?.boardNameStore?.getById(selectedBoard?.id);
  const isBoardOwner = project && boardStore ? isIAmOneOfBoardOwner(project, boardStore.owner) : false;
  const canWrite = isBoardOwner && !user?.isDemoUser;

  // Check board preference to see if there are draft changes
  // @ts-expect-error - userPreferences is dynamically set in bryntumContext
  const hasDraftChanges = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.aiContextCardInDraft, "false", true) === "true";

  // Publish all draft cards
  const handlePublish = async () => {
    if (!canWrite) {
      toast.error("You don't have permission to publish context cards");
      return;
    }

    // @ts-expect-error - selectedBoard.record type not fully defined
    if (!selectedBoard?.record?.id) return;

    // @ts-expect-error - selectedBoard.record type not fully defined
    const boardId = selectedBoard.record.id;

    setIsPublishing(true);
    try {
      // Call publish endpoint
      await publishContextCards(boardId);

      // Set board preference to false after successful publish
      // @ts-expect-error - userPreferences is dynamically set in bryntumContext
      userPreferences.updateSetting(PERSISTENCE_STATE_KEYS.aiContextCardInDraft, "false", true);

      // Show success notification
      toast.success("Changes published successfully");
    } catch (error) {
      console.error("Error publishing context cards:", error);
      toast.error("Failed to publish changes. Please try again.");
    } finally {
      setIsPublishing(false);
    }
  };

  return {
    hasDraftChanges,
    canPublish: canWrite && hasDraftChanges,
    handlePublish,
    isPublishing
  };
};
